import { render, staticRenderFns } from "./OrganizationInspectionsList.vue?vue&type=template&id=1b0e9326&"
import script from "./OrganizationInspectionsList.vue?vue&type=script&lang=js&"
export * from "./OrganizationInspectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports